// extracted by mini-css-extract-plugin
module.exports = {"tooltipBlock":"Tooltip_tooltipBlock__1LOc-","tooltipBody":"Tooltip_tooltipBody__10MIn"};